
define('text!templates/modules/dashboard/goal/list/goal-list-item.html',[],function () { return '<div class="chart"></div>\n<div class="goal-story-section">\n    <h5>{{#t}}goal:Story{{/t}}</h5>\n    <div class="no-goal-story">{{#t}}goal:No story data{{/t}}</div>\n    <div class="goal-story"></div>\n</<div>';});

